import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderStatsAggregateSlice = createApi({
    reducerPath: "orderStatsAggregate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        orderStatsAggregate: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/order/aggregate", params: data, method: "GET" }),
        }),
    }),
});

export const { useOrderStatsAggregateQuery } = orderStatsAggregateSlice;
